module.exports = __webpack_public_path__ + "media/6.8cca0dd2.mp3";